module.exports = __webpack_public_path__ + "fonts/Muli-Bold.b03f5ec.ttf";